import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';

import { Products } from '@/modules/catalog/views/Products';
import { CheckoutBar } from '@/modules/common/components/CheckoutBar';

import { EProductsAcquisitionSteps } from '@/modules/catalog/views/ProductsAcquisition/helpers';

import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductList',
  setup(__props) {

const productList = inject('productList') as Ref<IProductGetLastState[]>;
const isLoading = inject('isLoading') as Ref<boolean>;
const closeModal = inject('closeModal') as Ref<boolean>;
const isBuilder = inject('isBuilder') as Ref<boolean>;

const addProduct = inject('addProductToWallet', async (productId: string) => ({
  productId
}));
const removeProducts = inject(
  'removeProductFromWallet',
  async ({ productIds }: { productIds: string[] }) => ({
    productIds
  })
);
const changeStep = inject('changeStep', (step: EProductsAcquisitionSteps) => ({
  step
}));

const productLenght = computed(() => {
  return productList.value.length;
});

const checkoutSummary = computed(() => {
  return productLenght.value > 1
    ? `${productLenght.value} produtos selecionados`
    : productLenght.value === 1
    ? `${productLenght.value} produto selecionado`
    : `Nenhum produto selecionado`;
});

return { __sfc: true,productList, isLoading, closeModal, isBuilder, addProduct, removeProducts, changeStep, productLenght, checkoutSummary, Products, CheckoutBar, EProductsAcquisitionSteps }
}

})